import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerProviderCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { ProviderDto } from "@/features/ledger/api/dto";

/**
 * Enregistre un provider partenaire (`POST /Providers/add`) — réservé à
 * flashpay-superadmin / flashpay-admin.
 */
export const useCreateProvider = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "providers", "create"],
    mutationFn: (body: ProviderDto) =>
      mutateData({
        url: ledgerEndpoints.providers.add,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<ProviderDto>,
    onSuccess: () => {
      return invalidateAfterMutation(queryClient, ledgerProviderCacheKeys(), {
        resetListPage: true,
      });
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useCreateProvider failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
